import React, {Component} from 'react';
import {
    Grid,
    TextField,
    Typography
} from 'material-ui';
import Select from 'react-select';
import {Heading} from '../../../components/heading/heading';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';
import {numbersRegex} from '../../../components/helpers/constants';

class TagNewForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorTagosId: false,
            errorTagName: false,
            errorParentTag: false,
        }
    }

    render() {
        const {
            vocabularies,
            vocabularyLevels,
            tagParents,
            fetchVocabularyLevels,
            fetchTagParents,
            vocabularyId,
            levelId,
            parentTagId,
            tagName,
            tagTagosId,
            selectedVocabularyId,
            selectedLevel,
            selectedParentTag,
            selectedTagName,
            selectedTagosId,
            touched,
            classes,
            loading,
            clearFormFields,
            submitFormFields
        } = this.props;

        let isContinent = vocabularyId === 1 && levelId === 0;
        let isTypeOfWork = vocabularyId === 4;
        let isCustom = vocabularyId === 2;
        let isParent = vocabularyId !== 1 && levelId === 0;
        let showInputs = (vocabularyId !== undefined && levelId !== undefined) || (vocabularyId === 2);
        let hasTagosId = showInputs && !isContinent && !isTypeOfWork;
        let hasParentId = levelId > 0 && !isCustom;
        let disableSaveButton = false;
        disableSaveButton = (!touched) || loading;
        if (this.state.errorTagName || tagName === undefined || (tagName !== undefined && tagName.length < 1)) {
            disableSaveButton = true;
        }
        if (hasTagosId && (this.state.errorTagosId || tagTagosId === undefined)) {
            disableSaveButton = true;
        }
        if (hasParentId && (this.state.errorParentTag || parentTagId === undefined)) {
            disableSaveButton = true;
        }
        
        return (
            <span>
                <Heading title={'Add New Tag'} />
                <Grid container>
                    {<Grid item xs={12} md={4}>
                        <Typography variant="subheading" gutterBottom>Select Tag Type*:</Typography>
                        <Select
                            name="vocabularyId"
                            value={vocabularyId}
                            onChange={(vocabulary) => {
                                selectedVocabularyId(vocabulary);
                                fetchVocabularyLevels(vocabulary.id);
                            }}
                            options={vocabularies}
                            clearable={false}
                            labelKey={'display_name'}
                            valueKey={'id'}
                            required
                            placeholder={"Type to search and select tag type..."}
                        />
                    </Grid>}
                    {vocabularyLevels.length > 0 && !isCustom &&
                        <Grid item xs={12} md={isParent ? 2 : 4}>
                            <Typography variant="subheading" gutterBottom>Select Tag Level*:</Typography>
                            <Select
                                name="level"
                                value={levelId}
                                onChange={(level) => {
                                    selectedLevel(level);
                                    fetchTagParents(vocabularyId, level.id);
                                }}
                                options={vocabularyLevels}
                                clearable={false}
                                labelKey={'display_name'}
                                valueKey={'id'}
                                required
                                placeholder={"Type to search and select tag level..."}
                            />
                        </Grid>
                    }
                    {levelId > 0 && !isCustom &&
                        <Grid item xs={12} md={4}>
                            <Typography variant="subheading" gutterBottom>Select Tag Parent*:</Typography>
                            <Select
                                name="parentId"
                                value={parentTagId}
                                onChange={(parentTag) => {
                                    selectedParentTag(parentTag);

                                    if (parentTag === undefined) {
                                        this.setState({
                                            errorParentTag: true
                                        })
                                    } else {
                                        this.setState({
                                            errorParentTag: false
                                        })
                                    }
                                }}
                                options={tagParents}
                                clearable={false}
                                labelKey={'display_name'}
                                valueKey={'id'}
                                placeholder={"Type to search and select tag parent..."}
                            />
                            {(this.state.errorParentTag || parentTagId === undefined) && <span className={classes.tagsError}>Please select a parent tag!</span>}
                        </Grid>
                    }
                    {showInputs && 
                        <Grid item xs={12} md={isParent || isContinent ? 4 : 6} className={classes.tagsFormInputs}>
                            <TextField
                                id="term"
                                label="Tag Name"
                                value={tagName || ''}
                                onChange={(ev) => {
                                    selectedTagName(ev.target.value);

                                    if (ev.target.value === '') {
                                        this.setState({
                                            errorTagName: true
                                        })
                                    } else {
                                        this.setState({
                                            errorTagName: false
                                        })
                                    }
                                }}
                                fullWidth
                                helperText="Enter the tag term"
                                InputLabelProps={{
                                    required: true,
                                }}
                                error={tagName === undefined || (tagName !== undefined && tagName.length < 1)}
                            />
                        </Grid>
                    }
                    {showInputs && !isContinent && !isTypeOfWork &&
                        <Grid item xs={12} md={2} className={classes.tagsFormInputs}>
                            <TextField
                                id="tagosId"
                                label="Tagos ID"
                                value={tagTagosId || ''}
                                onChange={(ev) => {
                                    selectedTagosId(Number(ev.target.value));

                                    if (ev.target.value.match(numbersRegex)) {
                                        this.setState({
                                            errorTagosId: false
                                        })
                                    } else {
                                        this.setState({
                                            errorTagosId: true
                                        })
                                    }

                                    if (ev.target.value === '') {
                                        this.setState({
                                            errorTagosId: true
                                        })
                                    }
                                   
                                }}
                                fullWidth
                                type="tel"
                                helperText="Only numbers accepted"
                                InputProps={{
                                    inputProps: {min: 1}
                                }}
                                InputLabelProps={{
                                    required: true,
                                }}
                                error={tagTagosId === undefined || this.state.errorTagosId}
                            />
                        </Grid>
                    }
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <SaveButton
                            type="submit"
                            loading={loading}
                            disabled={disableSaveButton}
                            variant="raised"
                            color="primary"
                            className="floatRight"
                            onClick={() => submitFormFields()}
                        />
                        <BackButton
                            link={"/tags"}
                            style={{marginRight: 15}}
                            variant="raised"
                            className="floatRight"
                            onClick={() => clearFormFields()}
                        />
                    </Grid>
                </Grid>
            </span>
        )
    }
}

export default TagNewForm;


// WEBPACK FOOTER //
// ./src/containers/tags/forms/CreateTagForm.jsx